import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import toast from "react-hot-toast";
import { CustomDialog } from "../../../../components/customDialog/CustomDialog";
import { GET_DETALLE_LIQUIDACION } from "../../../../data/graphQL/queries/PreLiquidacion/getDetalleLiquidacion";
import { useGetColumnsDetalle } from "../../../PreLiquidacion/hooks/useGetColumnsDetalleLiquidacion";
import { GrillaLiquidacionesPaciente } from "../../../PreLiquidacion/components/GrillaLiquidacionesPaciente";

export const DialogDetalleLiquidacion = ({ open, setOpen, liquidacion, mes, anio, idTipoProfesional }) => {
    const columns = useGetColumnsDetalle(idTipoProfesional);

    const [getDetalle, { data, loading, error }] = useLazyQuery(GET_DETALLE_LIQUIDACION, {
        fetchPolicy: 'no-cache'
    });

    useEffect(() => {
        if (!open || !liquidacion?.idEvaluacion || !liquidacion?.idProfesional) return;

        getDetalle({
            variables: {
                idEvaluacion: liquidacion.idEvaluacion,
                idProfesional: liquidacion.idProfesional,
                mes,
                anio,
                idEvaluacionProfesional: liquidacion?.idEvaluacionProfesional,
                liquidacionFinal: true
            }
        });
    }, [open, liquidacion, mes, anio, getDetalle]);

    useEffect(() => {
        if (!error) return;
        toast.error('No se pudo cargar el detalle de la liquidación.');
    }, [error]);

    const rows = useMemo(
        () => data?.detalleLiquidacion?.valorEsperado ?? [],
        [data]
    );

    const totalDetalle = useMemo(
        () => rows.reduce((total, r) => total + (r.total || 0), 0),
        [rows]
    );

    const tieneJustificacion = liquidacion?.observacionAjuste &&
        liquidacion?.montoAjuste != null &&
        liquidacion.montoAjuste !== 0;

    return (
        <CustomDialog
            open={open}
            fullWidth
            boldDialogTitle
            maxWidth='md'
            dialogTitle='Detalle de la liquidación'
            onCancel={() => setOpen(false)}
            cancelText='Cerrar'
        >
            <GrillaLiquidacionesPaciente
                columns={columns}
                rows={rows}
                loading={loading}
                totalValue={totalDetalle}
                totalLabel='Total'
            />

            {tieneJustificacion && (
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                        Justificación
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            color: 'text.secondary'
                        }}
                    >
                        {liquidacion.observacionAjuste}
                    </Typography>
                </Box>
            )}
        </CustomDialog>
    );
};